import React, { useEffect, useState } from 'react';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import { Icon } from '../../utils/MuiIcons/Icon';
import { Global_Data } from '../../globalData/GlobalData';

const RenderSwitchComponent = ({ 
    data, 
    toggleSwitchState, 
    formData, 
    freeFormTabbleEditMainrecord, 
    multirecordData,
    id,
    multirecordSwitchStatus
}) => {

    const [switchToggleStatus, setSwitchToggleStatus] = useState();
    const [manualEdit, setManualEdit] = useState(false);
    const [dataset, setDataset] = useState();
    const { modalEditData } = Global_Data?.() || {};

    function isObject(value) {
        return value !== null && typeof value === 'object' && !Array.isArray(value);
    }

    useEffect(() => {
        if(!multirecordData){
            if ((Array.isArray(freeFormTabbleEditMainrecord) && freeFormTabbleEditMainrecord.length > 0) || isObject(freeFormTabbleEditMainrecord)) {
                setDataset(freeFormTabbleEditMainrecord);
            } else {
                setDataset(modalEditData);
            }
        }
    }, [modalEditData, freeFormTabbleEditMainrecord, multirecordData])

    useEffect(() => {
        if (data && !manualEdit) {
            if (dataset && (isObject(dataset) && Object.keys(dataset)?.length > 0)) {
                toggleSwitchState(data?.component?.sName, dataset?.[data?.component?.sName]);
                setSwitchToggleStatus(dataset?.[data?.component?.sName]);
            } else {
                if(!multirecordData){
                    toggleSwitchState(data?.component?.sName, data?.component?.sDefaultValue);
                    setSwitchToggleStatus(data?.component?.sDefaultValue);
                }
            }
        }
    }, [formData, data, dataset, switchToggleStatus])

    const handleSwitchToggle = (event) => {
        setManualEdit(true);
        if (event?.target?.checked) {
            setSwitchToggleStatus(data?.component?.sCheckedValue);
            toggleSwitchState(data?.component?.sName, data?.component?.sCheckedValue)
        } else {
            setSwitchToggleStatus(data?.component?.sUncheckedValue);
            toggleSwitchState(data?.component?.sName, data?.component?.sUncheckedValue)
        }
    }

    return (
        <>
            <FormControlLabel
                control={
                    <Switch
                        id={id ? `${data?.component?.sName}-${id}` : data?.component?.sName}
                        onChange={handleSwitchToggle}
                        checked={multirecordData ? ((
                            multirecordSwitchStatus == "Active" || 
                            multirecordSwitchStatus == "true" ||
                            multirecordSwitchStatus == "Yes"
                        ) ? true : false) : ((
                            switchToggleStatus == "Active" || 
                            switchToggleStatus == "true" ||
                            switchToggleStatus == "Yes"
                        ) ? true : false)}
                        {...data?.component?.sProps}
                        {...(data?.component?.sIcon && { checkedIcon: <Icon iconName={data.component.sIcon} /> })}
                        />
                }
                label={data?.component?.sLabel}
                {...data?.component?.sProps}
                sx={{
                    color: "text.primary",
                    ...data?.component?.sProps?.sx
                }}
            />
            {data?.component?.sHelper?.trim() &&
                <FormHelperText>{data?.component?.sHelper}</FormHelperText>
            }
        </>
    )
}

export default RenderSwitchComponent;